<script setup lang="ts">
</script>

<template>
  <router-view />
</template>

<style>
body {
  font-family: system-ui, sans-serif;
  max-width: 480px;
  margin: 0 auto;
  padding: 1rem;
  color: #1a1a1a;
}

button {
  cursor: pointer;
}

input {
  font-size: 1rem;
}
</style>
